import api from "../../api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { userLogout } from "../../features/userSlice";
import { useNavigate } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";

const useCreateTrainingName= () => {
  const queryClient = useQueryClient()
  //const { accessToken } = useSelector( state => state.user )
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { authState } = useOktaAuth()
  const accessToken = authState.accessToken.accessToken

  const createTrainingName = async (newTrainingName) => {
    await api.post("training/name/add", newTrainingName, {
      headers: {
        authorization: `Bearer ${accessToken}`
      }
    })
  }

  return useMutation(createTrainingName, {
    onSuccess: () => {
      toast.success("Created Successfully")
      queryClient.invalidateQueries(["queryAllTrainingNames"])
    },
    onError: (e) => {
      const statusCode = e.response.status
      if (statusCode === 402) {
        dispatch(userLogout())
        navigate("/authentication")
      }
      if (statusCode === 500 ){
      const { message } = e.response.data
      toast.error(message + ' or there may be duplicate trainings added. Please verify')
      }
    }
  })
}

export default useCreateTrainingName
